<template>
  <div class="mb-4">
    <h5>Payment</h5>

    <form
      class="col-md-6 border rounded p-2"
      @submit.prevent="generatePaymentLink"
    >
      <b-form-group class="col-md-10">
        <label class="form-label" for="">Client Name: </label>
        <input class="form-control" v-model="clientName" type="text" />
      </b-form-group>
      <b-form-group class="col-md-10">
        <label class="form-label" for="">Client Address: </label>
        <input class="form-control" v-model="clientAddress" type="text" />
      </b-form-group>
      <b-form-group class="col-md-10">
        <label class="form-label" for="">Client Email: </label>
        <input class="form-control" v-model="clientEmail" type="text" />
      </b-form-group>
      <b-form-group class="col-md-10">
        <label class="form-label" for="">Amount (US$): </label>
        <input class="form-control" v-model.number="amount" type="number" />
      </b-form-group>
      <button class="btn btn-primary ml-2">Pay</button>
    </form>
  </div>
</template>

<script>
export default {
  name: "StripePayment",
  data() {
    return {
      clientID: 252,
      clientName: "LIBERTY MUTUAL",
      clientAddress: "Boston, Massachusetts, United States",
      clientEmail: "customerservice@divvyengagement.com",
      amount: null,
    };
  },
  methods: {
    generatePaymentLink() {
      if (
        !this.clientID ||
        this.clientName === "" ||
        this.amount === null ||
        this.amount === "" ||
        this.clientEmail === ""
      ) {
        this.$store.dispatch("systemMessage/setModalMessage", {
          message: "Please fill all the fields",
        });
        return;
      }

      this.$store.commit("payment/TOGGLE_LOADING");
      this.$store
        .dispatch("payment/getPaymentLink", {
          clientID: this.clientID,
          clientName: this.clientName,
          clientAddress: this.clientAddress,
          clientEmail: this.clientEmail,
          amount: this.amount,
        })
        .then(({ invoiceDate, invoiceNumber, invoiceTotal, invoiceURL }) => {
          window.open(invoiceURL, "_blank");
        })
        .finally(() => {
          this.$store.commit("payment/TOGGLE_LOADING");
        });
    },
  },
};
</script>
